import styles from '../../styles/Home/Home.module.css'
import HeroSection from './hero-section'
import { useEffect, useMemo } from 'react'
import FAQsSection from './FAQs'
import { MixpanelTracking } from '../../MixPanel'
import { useScrollDirection } from '../../hooks/useScrollDirection'
import Enquiry from './Enquiry';
import QuickDelivery from './QuickDelivery';
import MarketBeats from './MarketBeats'
import GlobalStandards from './GlobalStandards'
import AffordableFinancing from './AffordableFinancing'
import HowItWorks from './HowItWorks'
import BulkDeals from './BulkDeals'
import LatestBlogs from './LatestBlogs'
import Head from 'next/head'

export default function Home() {
	
	const intersectionOptions = useMemo(() => {
		return {
			root : null,
			rootMargin : '0px',
			threshold : 0
		}
	}, []);
	const direction = useScrollDirection();
	
	useEffect(() => {
		const targets : String[] = [
			'quick-delivery',
			'market-beating-exclusive-price',
			'global-standards',
			'affordable-financing',
			'how-it-works',
			'bulk-deals',
			'enquiry-section',
			'faq-section',
			'blogs-section'
		];
		
		const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);

		targets.forEach((target : any) => {
			const element : any = document.getElementById(target);	
			
			if(element)
				observer.observe(element);
		})	
	}, []);

	// FUNCTIONS
	const intersectionCallback = (entries : any) => {
		entries.forEach((entry : any )=> {
			if(entry.isIntersecting) {
				const MixPanelData = {
					scrollDirection : direction,
					section : entry.target.id
				}
				MixpanelTracking.getInstance().scrolled(MixPanelData);
			}
		})
	}

	return (
		<div className={styles.container}>
			<Head>
				<title> 
					World's first online marketplace for active pharmaceutical ingredients. | APIdrug Platform
				</title>

				<meta 
					name='description'
					content={`Buy 5000+ active pharmaceutical ingredients at the best prices. Find quality-tested products, and reliable suppliers for free. 
					Check spot prices and group buying deals.`}
				/>
			</Head>

			<div className="hero-section" id='hero-section'>
				<HeroSection />
			</div>

			<QuickDelivery />

			<MarketBeats />

			<GlobalStandards />

			<AffordableFinancing />

			<HowItWorks />

			<BulkDeals />

			<Enquiry />

			{/* <RoubustTechPlatform /> */}

			{
				<div id='faq-section' className="live-deals --align" style={{ paddingTop: 50, paddingBottom: 60, minHeight : 696 }}>
					<h1 className='text-[28px] lg:text-[48px] font-semibold text-theme-dark-saffron pb-[65px]' >Frequently Asked Questions (FAQs)</h1>
					<FAQsSection />
				</div>
			}

			{/* <LatestBlogs /> */}

			{/* <LeadingBrands /> */}
		</div>
	)
}
